import { apiGet } from '../requests.ts';

function getInternalOpportunities(searchQuery = ''): Promise<any> {
  return apiGet(`/api/account/internal-opportunities${searchQuery}`);
}

export { getInternalOpportunities };
